module.exports = __webpack_public_path__ + "img/74032d6e3d87207465fbc26da35677f9.png";